import React from 'react'
import { ptBR } from '@/src/locales/ptBR'
import StyledDataGrid from './styled-data-grid'

type SelectionDataGridProps = React.ComponentProps<typeof StyledDataGrid>

const SelectionDataGrid: React.FC<SelectionDataGridProps> = (props) => {
  return (
    <StyledDataGrid
      {...props}
      disableColumnFilter
      disableColumnSelector
      disableColumnSorting
      disableColumnMenu
      disableRowSelectionOnClick
      onCellKeyDown={(_, e) => e.stopPropagation()}
      getRowHeight={() => 'auto'}
      localeText={ptBR}
    />
  )
}

export default SelectionDataGrid
